import { Input } from 'antd';
import { TFieldRendererProps } from '@/types/TSmartCRM';
import { EFieldMode } from 'src/enums/ESmartCRM';

export const TextRenderer = ({
	value,
	onChange,
	mode,
	size,
	disabled = false,
	placeholder,
}: TFieldRendererProps) => {
	if (mode === EFieldMode.DISPLAY) {
		return <span>{(value as string) || '-'}</span>;
	}

	return (
		<Input
			value={value as string}
			onChange={(e) => onChange?.(e.target.value)}
			size={size}
			disabled={disabled}
			placeholder={placeholder}
		/>
	);
};
